import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Disclosure } from "@headlessui/react";
import {
  Bars2Icon,
  XMarkIcon,
  ArrowRightOnRectangleIcon,
} from "@heroicons/react/24/outline";
import { Secundary } from "../buttons/navigation/Secundary";
import { navLogin } from "./options/MenuOptions";
// Dropdown
import { MyCount } from "./dropdown/MyCount";
import { Access } from "./dropdown/Access";

import { closeSession } from "../../utils/closeSession";
import { HttpRequest } from "../../services/httpRequest";
import { variablesGlobales } from "../../configs/variables";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function SimpleNavbar(props) {
  const navigate = useNavigate();
  const hasToken = localStorage.getItem("token");
  const typeUSer = localStorage.getItem("type_user");
  const doc = localStorage.getItem("doc");
  const [firstname, setFirstname] = useState("");

  const handleCloseSession = () => {
    closeSession();
    navigate("/ingresar");
  };

  const loadInfoUser = async () => {
    try {
      const data = await HttpRequest.getInfoUser(doc);
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const navigation = [
    {
      name: "Requisitos",
      href: "/requisitos",
      current: props.current6,
    },
    {
      name: "Tasas y tarifas",
      href: "/tarifas",
      current: props.current3,
    },
    {
      name: "Preguntas frecuentes",
      href: "/faqs",
      current: props.current5,
    },
    {
      name: "Nosotros",
      href: "/nosotros",
      current: props.current2,
    },
  ];

  useEffect(() => {
    const loadInfo = async () => {
      let info = await loadInfoUser();
      return info;
    };

    loadInfo()
      .then((basicInfo) => {
        setFirstname(basicInfo?.firstname);
      })
      .catch((e) => console.log(e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Disclosure
      as="nav"
      className="fixed z-30 w-full bg-transparent font-walsheim text-lg"
    >
      {({ open }) => (
        <>
          <div className="px-4 sm:px-6 lg:px-20">
            <div className="flex justify-between h-24">
              <div className="flex">
                <a className="flex-shrink-0 flex items-center" href="#">
                  <img
                    className="block md:hidden h-12 w-auto"
                    src="/svg/imagotipo-galilea-14.svg"
                    alt="Galilea"
                  />
                  <img
                    className="hidden md:block h-14 w-auto"
                    src="/svg/imagotipo-galilea-02.svg"
                    alt="Galilea"
                  />
                </a>
              </div>
            </div>
          </div>
        </>
      )}
    </Disclosure>
  );
}
